export interface UserFilter {
    userIds: number[];
    branchesIds: string[];
    showDeleted: boolean,
    showDisabled: boolean;
    view: UserView;
    query: string;
}

export enum UserView {
    AUTOCOMPLETE = 'AUTOCOMPLETE',
    LIMITED_VIEW = 'LIMITED_VIEW',
    FULL_USER_VIEW = 'FULL_USER_VIEW'
}